// eventBus.ts
import Emittery from "emittery";

export const EventTypes = {
  UnselectedSeatMapSectionClicked: "unselectedSeatMapSectionClickedEvent",
  RefreshSeatMap: "refreshSeatMapEvent",
};

export const eventBus = new Emittery();
